import ReactGA from 'react-ga4';

class DeferredCapture {
  /**
   * Queue of deferred hits to be processed when ready. When undefined, hits
   * can safely be sent without delay.
   */
  queue;
  /**
   * constructor for creating the DeferredCapture object
   * @param defer type of {defer: boolean}
   */
  constructor({ defer = false }) {
    this.queue = defer ? [] : void 0;
  }
  /**
   * Indicates that deferred capture may now proceed.
   */
  setReady() {
    if (this.queue) {
      this.queue.forEach(this.sendDeferred);
      this.queue = void 0;
    }
  }
  /**
   * Either forwards the event directly to GA, or (if configured) enqueues the
   * event hit to be captured when ready.
   * @param eventDetails type of UaEventOptions object
   * @param metadata any object that can be passed as additional parameter to the event
   */
  event(eventDetails, metadata = {}) {
    const data = {
      ...eventDetails,
      ...metadata
    };
    if (this.queue) {
      this.queue.push({
        hitType: eventDetails.action,
        data: {
          ...data,
          timestamp_micros: Date.now() * 1e3
        }
      });
      return;
    }
    ReactGA.event(eventDetails.action, data);
  }
  /**
   * Sends a given hit to GA, decorated with the correct queue time.
   * @param hit Hit object
   */
  sendDeferred(hit) {
    ReactGA.event(hit.hitType, {
      ...hit.data
    });
  }
}

export { DeferredCapture };
//# sourceMappingURL=DeferredCapture.esm.js.map
